import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";

const AdminStatsGoal = lazy(() => import("@/pages/admin/AdminStatsGoal"));

export const Route = createFileRoute("/admin/statistik/konverteringar/$goal")({
  component: () => <AdminStatsGoal />,
});
